import IMAGE_COMMENTS from "../../../assets/comments.png";
import { Alert, Modal } from "antd";

const info = () => {
  Modal.info({
    title: "Solicitar soporte - Admisión UNBJG",
    content: (
      <div>
        <h1>Si tienes dudas o problemas con tu inscripción puedes dejarnos un mensaje a:</h1>
        <br />
        <ul>
          <li>
            - Whatsapp: &nbsp;&nbsp;
            <a className="underline text-blue-500" href="https://wa.me/51926230680">
              926 230 680
            </a>
          </li>
          <li>- Correo 1: &nbsp;&nbsp;soporte.admision@unjbg.edu.pe</li>
          <li>- Correo 2: &nbsp;&nbsp;admision@unjbg.edu.pe</li>
          <li></li>
        </ul>
      </div>
    ),

    onOk() {}
  });
};

function ButtonHelp(props) {
  return (
    <div>
      <Alert
        className="fixed z-90 bottom-12 right-24"
        message="¿En qué te puedo ayudar?"
        type="info"
        closable
      />

      <button
        onClick={info}
        title="Solicitar ayuda"
        className="fixed z-10 bottom-10 right-8 bg-gray-200 w-16 h-16 rounded-full drop-shadow-lg flex justify-center items-center text-white text-4xl hover:bg-gray-200 hover:drop-shadow-2xl hover:animate-bounce duration-300"
      >
        <img
          className="rounded w-10 h-10"
          alt="Botón de ayuda"
          src={
            IMAGE_COMMENTS ||
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG0AAABPCAYAAADhnEtrAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAQxSURBVHhe7ZrJSiNRFIZPnIdooiK6cNqJICqCgihOoIjYwaALN4qbFnwGH0AfQ3wAN25tXPoGPoDuWuMUoyZO7X/IpdPpBkVMvH/6fFB0khpi11fn3P9WJZBIJF7EoKIo/a9BhEkjxKQRYtIIMWmEmDRCTBohJo0Qk0aISSPEpBFi0ggxaYSYNEJMGiEmjRCTRohJI8SkEWLSCDFphJg0QkwaISaNEJNGiPe/MH55yf+fFwgE0q/8xGtpEFZaWirFxcXpT3LP8/OzpFIpr8V5Kw3CysvLJRaLyc3NjRQV5b6TQ1hlZaU0NDTI4+Ojt+K8lAZhZWVlcnr6UzY3tyQUCqXX5B5cIBsbGxIOh72tOG+lVVRUyPHxsezs7EgwGEyvyS0QdH19LcvLy9LR0SH39/deSvM6PeKEvRVEsP6tbd6LO04+x9CPQBv5cYJRCWhnd3d3Ogb9L1BKgzCMN+3t7TI7OysDAwNSVVUlDw8P6S0KG0ppkNPc3CwLCwsyODgoMzMzMjw8/K52WghQSnt6epLGxkadw70GKZXY1NSkiROxvdChlIY528XFhVZVdXW1yru6upJkMpmX+dxXQ/k/xKT75ORE9vb25OjoSA4PD+Xg4Ieuy47oEIuQgmoslNZJe1lCHITt7u7K/v6+xOMJrbhsEFgw/qF9Foo4WmmoKEzAMY5B1r+EYSqA9rm0tCSRyDedpBdCwqQeABA6sNTU1GhFZeLmbYuLi1JSUiK1tWGJRqO6HYIMM7TSIOv29lbm5uY0+uMuhqsiSIG0SCSirRGT8FQqKS0tLTqvQ+JkTpmU0nDCIWJ0dFS6u7t1vJqamtKWCVmopsnJSenp6dFE6YAsTMTHxsb0c1ZxdNKcsK6uLhkZGdFxC+97e3tVyOXlpfT19Ul/f79+juABmS5VYnvs19nZqa8ZxdFJQxW1tbXJ9PS0CsFJx4LPIWNiYkLGx8d1W7TJzCkAXmNb7If9cRzGYEIlzZ3g+fmo3mvMvEkMQRCC1ofxza2DoMwFYB1SJYIJXrOJo5GGk4tYv7b2XUKhWn2PVJi5uKrCXZHsddkL9sfD1fX1dT0u3rNAIw3j09DQ0GuFBOXsLKahAo9lPrpgfxwHFYfj4vgseP3kGreqtre3dR6GFlZfX/9Hm/sMXEg5Pz/XiovH47K6uiqtra0qMnNM9AWqnxvksoWhZQJU4crKioYUX6V53R5xvlBhCBkuCeZqcd+BFIr3n1nNn4230lxQwHMzpMF8LAgw+L66ujqvg4nXv3tEy8IYg5aFqz/XYMqAYIKLBdLy8Z0fwVtpwInL54NNiPNZGPBaGviKscVnYcB7acbf0Eyujd+YNEJMGiEmjRCTRohJI8SkEWLSCDFphJg0QkwaISaNEJNGiEkjxKQRYtIIMWmEmDRCTBohJo0Qk0aISSPEpNEh8gsH+kq3nbGgPQAAAABJRU5ErkJggg=="
          }
        />
      </button>
    </div>
  );
}

export default ButtonHelp;
